import { programStateFallbackLabel } from '../../components/imageOverlays/programStateLabel';
import { ProgramState } from '../../forces/assetDetails/assetDetails.types';

const TERMINAL_PUNCTUATION = /[.,:;!?]$/;

/**
 * Joins the segments of an accessible name with a pause between them. The first one is expected to be
 * the title and is kept verbatim, so the name still contains the visible label (WCAG 2.5.3) even for a
 * title like "S.W.A.T.".
 */
export const joinLabelSegments = (segments: Array<string | undefined>): string =>
  segments
    .map((segment, index) => (index === 0 ? segment?.trim() : segment?.trim().replace(TERMINAL_PUNCTUATION, '')))
    .filter((segment): segment is string => !!segment)
    .reduce((label, segment) => {
      if (!label) {
        return segment;
      }
      return TERMINAL_PUNCTUATION.test(label) ? `${label} ${segment}` : `${label}. ${segment}`;
    }, '');

/** The spoken version of a program state, falling back to the same wording as the image overlays. */
export const getProgramStateLabel = (state: ProgramState): string | undefined => {
  switch (state.type) {
    case 'Default':
      return state.label;
    /* the mapper defaults missing labels to '', so the overlays fall back on falsy – not just nullish */
    case 'Live':
      return state.label || programStateFallbackLabel.live;
    case 'NoAccess':
      return state.label || programStateFallbackLabel.noAccess;
    case 'Planned':
      return state.label || programStateFallbackLabel.planned;
    case 'Expired':
      return state.label || programStateFallbackLabel.expired;
    case 'Rented':
      return undefined;
    default: {
      const _exhaustiveCheck: never = state;
      return undefined;
    }
  }
};
